import { TypePolicies } from '@apollo/client';

// Please add fragments for these key fields in keyFieldFragments so that consumers can
// more easily fetch the data they need without causing errors in the cache

const cacheKeyFields: TypePolicies = {
  AssociationDefinition: {
    keyFields: ['associationTypeId', 'associationCategory'],
  },
  // All objects/types share a global default properties card with `cardId: 0`.
  // To avoid collisions, include objectType and subjectId in the cache key.
  //
  // The same card and cardId (ex: the contacts-to-companies association card)
  // can be queried for different subjects. We don't want to share card data for
  // subject A with card data for subject B, _even for the same cardId_, so include
  // the objectType and subjectId in the cache key.
  //
  // In order to support this, all queries for `CrmRecordCard` must also fetch:
  // ```
  // cardId
  // crmObject {
  //   __typename
  //   id
  // }
  // ```
  CrmRecordCard: {
    keyFields: ['cardId', 'crmObject', ['__typename', 'id']],
  },
  // Auto-generated `ObjectRequirements` for custom object required properties
  // all have the same placeholder id=-1. To avoid cache collisions between different
  // auto-generated requirements, use the requirement type + identifier instead when
  // the id is known to not be unique.
  // See https://git.hubteam.com/HubSpot/CRM-Issues/issues/6716
  // Id is also part of the keyField because the GraphQL endpoint for the
  // record creator returns required properties for pipelines AND
  // properties used in the record creator. In that instance, requirementType + requirementIdentifier
  // is not enough to distinguish between the same property used in two different locations!
  ObjectRequirement: {
    keyFields: ['requirementType', 'requirementIdentifier', 'id'],
  },
  PropertyDefinition: {
    keyFields: ['name', 'objectTypeId'],
  },
  Pipeline: {
    keyFields: ['pipelineId'],
  },
  PipelineStage: {
    keyFields: ['stageId'],
  },
  // CardContainers aren't guaranteed to have a unique ID because of how their ids are generated.
  // Until this is resolved, the safest thing to do is not normalize them so they are not considered individual
  // cache items, which prevents the cache collisions.
  // https://www.apollographql.com/docs/react/caching/cache-configuration/#disabling-normalization
  CardContainer: {
    keyFields: false,
  },
};

export default cacheKeyFields;
